import { render, staticRenderFns } from "./DetailHistoryAlert.vue?vue&type=template&id=288dfd88&scoped=true"
import script from "./DetailHistoryAlert.vue?vue&type=script&lang=js"
export * from "./DetailHistoryAlert.vue?vue&type=script&lang=js"
import style0 from "./DetailHistoryAlert.vue?vue&type=style&index=0&id=288dfd88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288dfd88",
  null
  
)

export default component.exports